import ReportDetail from './audit-report.details';
import ReportList from './audit-report.list';

export const ReportStores = {
  detail: ReportDetail,
  list: ReportList,
};
